"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadSrc;
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
/**
 * Load JavaScript from source
 * This helper comes from htmlScriptLoader.jsx in web-registry
 * src is a String, attributes is an Object
 */
function loadSrc(src, attributes, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.async = false;
  if (attributes) {
    var keys = Object.keys(attributes);
    keys.forEach(function (key) {
      var value = attributes[key];
      script.setAttribute(key, value.toString());
    });
  }
  script.onload = function () {
    if (typeof callback === 'function') callback();
  };
  document.body.appendChild(script);
}